import { useMemo } from "react";
import { bool } from "prop-types";
import { observer } from "mobx-react";
import { Totals } from "@repo/utils";
import {
  TotalWorkTypeBufferTooltip,
  useEstimateEditorSettings,
  useEstimateStructure,
  usePresetFieldNames,
  useVisibilityModeCellClassName
} from "@tools";
import { TotalContainer } from "../components";

export const TotalHours = observer((containerProps) => {
  const structure = useEstimateStructure();
  const { isProposal, allowEdition } = useEstimateEditorSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  const {
    settings,
    visibility,
    displayTotalHours,
    displayTotalHoursMax,
    showMaxTotalHours,
    usedBuffers,
  } = structure;
  const {
    timeModifier,
    usedRoundDecimals,
    maxValuesAsBuffer,
  } = settings;
  const { hideTotalHours } = visibility;
  const className = useVisibilityModeCellClassName(hideTotalHours);
  
  const presetText = useMemo(() => (
    timeModifier === 1 ? "pt-totalEstimateHours" : "pt-totalEstimateDays"
  ), [timeModifier]);
  
  const displayUsedBuffers = useMemo(() => (
    allowEdition && displayTotalHours && structure.hasUsedWorkTypeBuffers()
  ), [ displayTotalHours, allowEdition, usedBuffers ]);
  
  return (
    <TotalContainer
      totalName={ Totals.HOURS }
      min={displayTotalHours}
      max={displayTotalHoursMax}
      showMaxValue={showMaxTotalHours}
      textSmaller
      decimals={usedRoundDecimals}
      showDecimals
      className={className}
      valueClassName={presetText}
      visibilityHidden={hideTotalHours}
      setVisibility={visibility.setHideTotalHours}
      symbolEnd={getFieldName(presetText)}
      applySuffixSpacing
      minTooltipMessage={ displayUsedBuffers && !maxValuesAsBuffer && <TotalWorkTypeBufferTooltip /> }
      maxTooltipMessage={ displayUsedBuffers && <TotalWorkTypeBufferTooltip isMax /> }
      { ...containerProps }
    />
  );
})

TotalHours.propTypes = {
  showDivider: bool,
}